import { trackRefund } from '../../../../../../shared/analytics/e-commerce/trackRefund';
import { IBooking } from '../../../../../domain/booking/models/IBooking';

export function trackBookingCanceled(booking: IBooking) {
	if (!booking.reference) {
		return;
	}

	trackRefund({
		transactionId: booking.reference,
	});
}
